module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    attrs: {
      "id": "osc-logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button center"
  }, [_c('a', {
    attrs: {
      "href": "#admission"
    },
    on: {
      "click": function($event) {
        _vm.admission()
      }
    }
  }, [_vm._v("錄取名單")])])]), _vm._v(" "), _c('navbar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476c8e5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 86
// module chunks = 0